/** Shared debounce for cart quantity writes (side cart + PDP). */
export const CART_QUANTITY_DEBOUNCE_MS = 400;
